import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatIcon } from '@angular/material/icon'
import { IncidentService } from '../../services/incident/incident.service'
import {
    FormBuilder,
    FormsModule,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms'
import {
    MatError,
    MatFormField,
    MatFormFieldModule,
    MatLabel,
} from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { NgIf } from '@angular/common'
import { FormUtils } from '../../utils'
import { ToastrService } from 'ngx-toastr'
import { HttpErrorResponse } from '@angular/common/http'
import { LoadingService } from '../../services/loadingService/loading.service'

@Component({
    selector: 'app-encrypt-data',
    standalone: true,
    imports: [
    MatIcon,
    MatFormField,
    ReactiveFormsModule,
    FormsModule,
    MatLabel,
    MatInput,
    MatError,
    MatFormFieldModule,
    NgIf,
],
    templateUrl: './encrypt-data.component.html',
    styleUrl: './encrypt-data.component.css',
})
export class EncryptDataComponent {
    otpRequested = false
    errorMsg: string[] | null = null
    constructor(
        private dialogRef: MatDialogRef<EncryptDataComponent>,
        private incidentService: IncidentService,
        private fb: FormBuilder,
        private toastr: ToastrService,
        private loadingService: LoadingService,
        @Inject(MAT_DIALOG_DATA) public data: { id: number; secure: boolean }
    ) {}

    ngOnInit(): void {
        this.incidentService.asyncErrorValidation$.subscribe((error) => {
            if (error) {
                this.errorMsg = FormUtils.parseErrorMsgs(error)
            }
        })
    }

    otpForm = this.fb.group({
        otp: ['', [Validators.required, Validators.minLength(4)]],
    })

    closeDialog() {
        this.dialogRef.close()
    }

    requestOtp() {
        this.loadingService.show(true);
        this.incidentService.generateOtp().subscribe({
            next: () => {
                this.loadingService.show(false);
                const msg = `Se ha enviado un código OTP a tu correo.`
                this.otpRequested = true
                this.toastr.success(msg, 'Exitoso!', {
                    progressBar: true,
                    timeOut: 5000,
                })
            },
            error: ({}: HttpErrorResponse) => {
                if (this.errorMsg) {
                    this.toastr.error('Error: ' + this.errorMsg, undefined, {
                        progressBar: true,
                        timeOut: 5000,
                    })
                }
            },
        })
    }

    encrypt() {
        if (this.otpForm.invalid) {
            return
        }
        const otp: string = this.otpForm.value.otp!
        this.incidentService.encryptIncident(this.data.id, otp).subscribe({
            next: (res) => {
                this.dialogRef.close()
                const msg = `la operación se completo correctamente!`
                this.toastr.success(msg, 'Exitoso!', {
                    progressBar: true,
                    timeOut: 5000,
                })
            },
            error: ({}: HttpErrorResponse) => {
                if (this.errorMsg) {
                    this.toastr.error('Error: ' + this.errorMsg, undefined, {
                        progressBar: true,
                        timeOut: 5000,
                    })
                }
            },
        })
    }
}
